export default {
  setLibraryPath(state, path) {
    state.libraryPath = path;
  },
};
